import { GetterTree } from 'vuex';
import { ProfileState, Page } from '@/store/profile/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters: GetterTree<ProfileState, RootState> = {
  getSession(state) {
    return state.session;
  },
  getPages(state): Array<Page> {
    const roleType = state?.session?.user_pimcore?.role?.role_type;
    const pages = _.cloneDeep(state.pages);
    return pages.map<Page>((v: Page) => {
      if (v.isAllowed !== true && v.allowedRoles && v.allowedRoles.length) {
        v.isAllowed = v.allowedRoles.includes(roleType);
      }
      return v;
    });
  },
};

export default getters;
